import React, { useEffect, useContext, useRef } from "react";
import "./VisibilitySelect.scss";
import "./Adaptations.scss";
import SelectArrow from "../../../static/img/Arrow 2.svg";
import { MainContext } from "../../../contexts/MainContext";

export default function VisibilitySelect() {
    const {
        setSelectComActive,
        setSelectProActive,
        setBtnActive,
        selectActive,
        setSelectActive,
        selectedItems,
        setSelectedItems,
    } = useContext(MainContext);

    const menuRef = useRef(null);

    const array = ["landmarks", "malls", "schools", "hospitals"];

    const selectHandleToggle = () => {
        setSelectActive((prev) => !prev);
        setSelectComActive(false);
        setSelectProActive(false);
        setBtnActive(false);
    };

    // Updated radio-like logic: Allow unselecting the currently selected item.
    const handleRadioChange = (item) => {
        if (selectedItems[0] === item) {
            setSelectedItems([]); // Unselect if already selected
        } else {
            setSelectedItems([item]);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setSelectActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef, setSelectActive]);

    return (
        <div className="select-con" ref={menuRef}>
            {/* Group for toggle and dropdown */}
            <div className="select-group">
                <div
                    onClick={selectHandleToggle}
                    className={`select${selectActive ? " active" : ""}`}
                >
                    <img src={SelectArrow} alt="top-arrow" />
                    <span>visibility</span>
                </div>
                <div
                    className={`select-bottom${selectActive ? " visible" : ""}`}
                >
                    {array.map((item) => (
                        <label key={item} className="visibility-form-control">
                            <input
                                type="checkbox"
                                name="visibility"
                                checked={selectedItems[0] === item}
                                onChange={() => handleRadioChange(item)}
                            />
                            <span>{item}</span>
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}
